<template>
  <CCard class="media-library-page">
    <CCardHeader><strong>کتابخانه رسانه</strong></CCardHeader>
    <CCardBody>
      <MediaLibraryBrowser ref="browser"/>
    </CCardBody>
    <div class="file-drop-overlay" v-if="page_dragging">
      <div>فایل را اینجا رها کنید
        <small>آپلود در پوشهٔ جاری کتابخانه</small>
      </div>
    </div>
  </CCard>
</template>

<script>
import MediaLibraryBrowser from './MediaLibraryBrowser.vue';

const hasFiles = (ev) => !!(ev.dataTransfer && Array.from(ev.dataTransfer.types || []).indexOf('Files') >= 0);

// Whole-page drop target: files dropped anywhere on this page (outside the browser's own
// drop area, which handles itself) are uploaded into the browser's current folder.
export default {
  name: 'MediaLibrary',
  components: {MediaLibraryBrowser},
  data() {
    return {page_dragging: false, depth: 0};
  },
  mounted() {
    window.addEventListener('dragenter', this.onEnter);
    window.addEventListener('dragover', this.onOver);
    window.addEventListener('dragleave', this.onLeave);
    window.addEventListener('drop', this.onDrop);
  },
  beforeDestroy() {
    window.removeEventListener('dragenter', this.onEnter);
    window.removeEventListener('dragover', this.onOver);
    window.removeEventListener('dragleave', this.onLeave);
    window.removeEventListener('drop', this.onDrop);
  },
  methods: {
    inBrowser(ev) {
      return !!(ev.target && ev.target.closest && ev.target.closest('.mlb'));
    },
    onEnter(ev) {
      if (!hasFiles(ev)) return;
      this.depth++;
      this.page_dragging = !this.inBrowser(ev);
    },
    onOver(ev) {
      if (!hasFiles(ev)) return;
      ev.preventDefault();
      this.page_dragging = !this.inBrowser(ev);
    },
    onLeave(ev) {
      if (!hasFiles(ev)) return;
      this.depth = Math.max(0, this.depth - 1);
      if (this.depth === 0) this.page_dragging = false;
    },
    onDrop(ev) {
      this.depth = 0;
      this.page_dragging = false;
      if (!hasFiles(ev)) return;
      ev.preventDefault();
      if (this.inBrowser(ev)) return; // MediaLibraryBrowser already handled it
      const files = Array.from(ev.dataTransfer.files || []);
      if (files.length && this.$refs.browser) this.$refs.browser.upload_files(files);
    },
  },
};
</script>